var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"ma-16"},[_c('v-list-item-content',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.lastOne.body)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }